const Comp = ((win, doc) => {
  doc.componentRegistry = {};
  doc.nextId = 0;

  class Component {
    constructor(props) {
      // Assign a new id to the component
      this.id = ++doc.nextId;
      doc.componentRegistry[this.id] = this;

      // Define parent component if exists
      this.parent = props.parent || null;
      // Define parent component watchers to emit each prop when changed
      this.watchers = props.watchers || null;

      this.temp = null;

      // Define data props and element that component should mount to that
      this.state = {
        elem: props.elem,
        data: props.data || null,
      };
    }

    // Set state props method
    setState(props) {
      Object.keys(props).forEach((key) => {
        // Merge props new values into state object
        this.state.data[key] = props[key];
        // If watchers exist and prop is in watchers list, then call emit method in the parent component
        if (this.watchers) {
          Object.keys(this.watchers).forEach((k) => {
            if (key === k) {
              if (this.parent && typeof this.parent.emit === 'function') {
                this.parent.emit({ [this.watchers[k]]: props[key] });
              }
            }
          });
        }
      });

      // Call update method to re-render the component with new props
      this.update();
    }

    // Re-render component method
    update() {
      // If the component has element re-render that if not, update the parent component to render the changes to the view
      if (this.state.elem) {
        this.mount();
      } else if (this.parent) {
        this.parent.update();
      }
    }

    // Define the template elements
    template() {
      this.temp = `
        <div></div>
      `;

      return this.temp;
    }

    // Render the component without mounting that
    render() {
      const { data } = this.state;
      // Get the template, data will be passed as props to the template
      const temp = typeof this.template === 'function' ? this.template(data) : this.template;

      return temp;
    }

    // Mount the element to the view
    mount() {
      const { elem, data } = this.state;

      // If elem is an element, use it and if it's a selector, get it.
      const el = typeof elem === 'string' ? doc.querySelector(elem) : elem;

      if (!elem) return;

      // Get the template, data will be passed as props to the template.
      const temp = typeof this.template === 'function' ? this.template(data) : this.template;

      // if the element is same as template, do nothing
      if (el.innerHTML === temp) return;

      // Render the template into the element
      el.innerHTML = temp;

      // Dispatch a render event https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
      if (typeof win.CustomEvent === 'function') {
        const event = new CustomEvent('render', {
          bubbles: true,
        });
        el.dispatchEvent(event);
      }
    }
  }

  return Component;
})(window, document);

export default Comp;
